import { render, staticRenderFns } from "./StocksTable.vue?vue&type=template&id=22538f04&scoped=true&"
import script from "./StocksTable.vue?vue&type=script&lang=js&"
export * from "./StocksTable.vue?vue&type=script&lang=js&"
import style0 from "./StocksTable.vue?vue&type=style&index=0&id=22538f04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22538f04",
  null
  
)

export default component.exports